import { v4 as uuid } from "uuid";

import constants from "../assets/constants";
import { deepMerge } from "../utils/helpers";

var defaultModelObjectCreator = require("json-schema-defaults");
export const createOmniDataModelObject = schemaName => {
  try {
    // const objectDef = omniDataModelObjects.find(
    //   odmObject => odmObject.schemaName.toLowerCase() === schemaName.toLowerCase()
    // );
    const schemaJson = require(`./schema/${schemaName}.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);
    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

//#region Validate Methods

export const validateUserODM = userODM => {
  try {
    let validatedODM = deepMerge(createNewUser(), userODM);

    const subSchemaJson = require(`./schema/user/userData.json`);
    validatedODM.omniData = {
      ...defaultModelObjectCreator(subSchemaJson),
      ...userODM.omniData,
    };

    if (!validatedODM.omniRelationships.hasOwnProperty("relatedData")) {
      validatedODM.omniRelationships["relatedData"] = [];
    }

    if (!validatedODM.omniData.hasOwnProperty("birthdate")) {
      validatedODM.omniData["birthdate"] = null;
    }

    //the fuck is this all about? GD xlabs
    if (!validatedODM.omniData.hasOwnProperty("address")) {
      validatedODM.omniData["address"] = null;
    }

    if (!userODM.omniData.hasOwnProperty("address")) {
      userODM.omniData["address"] = {};
    }

    const addressJson = require(`./schema/address.json`);
    validatedODM.omniData.address = {
      ...defaultModelObjectCreator(addressJson),
      ...userODM.omniData.address,
    };

    if (validatedODM.omniData.patientData != null) {
      const subSchemaJson = require(`./schema/user/patientData.json`);
      validatedODM.omniData.patientData = {
        ...defaultModelObjectCreator(subSchemaJson),
        ...userODM.omniData.patientData,
      };
    }

    if (validatedODM.omniData.providerData != null) {
      const subSchemaJson = require(`./schema/user/providerData.json`);
      validatedODM.omniData.providerData = {
        ...defaultModelObjectCreator(subSchemaJson),
        ...userODM.omniData.providerData,
      };
    }

    if (validatedODM.omniData.partnerData != null) {
      const subSchemaJson = require(`./schema/user/partnerData.json`);
      validatedODM.omniData.partnerData = {
        ...defaultModelObjectCreator(subSchemaJson),
        ...userODM.omniData.partnerData,
      };
    }

    if (validatedODM.omniData.administratorData != null) {
      const subSchemaJson = require(`./schema/user/administratorData.json`);
      validatedODM.omniData.administratorData = {
        ...defaultModelObjectCreator(subSchemaJson),
        ...userODM.omniData.administratorData,
      };
    }

    return validatedODM;
  } catch (error) {
    console.log("Unable to validateUserODM: " + error);
    return null;
  }
};

export const validateAssessmentODM = assessmentODM => {
  try {
    let validatedODM = deepMerge(createNewAssessment(), assessmentODM);

    if (!validatedODM.omniRelationships.hasOwnProperty("relatedData")) {
      validatedODM.omniRelationships["relatedData"] = [];
    }

    const scheduleJson = require(`./schema/user/administratorData.json`);
    validatedODM.omniSchedule = {
      ...defaultModelObjectCreator(scheduleJson),
      ...assessmentODM.omniSchedule,
    };

    return validatedODM;
  } catch (error) {
    console.log("Unable to validateAssessmentODM: " + error);
    return null;
  }
};

export const validatePracticeODM = practiceODM => {
  try {
    let validatedODM = deepMerge(createNewPractice(), practiceODM);

    if (!validatedODM.omniRelationships.hasOwnProperty("relatedData")) {
      validatedODM.omniRelationships["relatedData"] = [];
    }

    const addressJson = require(`./schema/address.json`);
    validatedODM.omniData.address = {
      ...defaultModelObjectCreator(addressJson),
      ...practiceODM.omniData.address,
    };

    const coordinatesJson = require(`./schema/coordinates.json`);
    validatedODM.omniData.coordinates = {
      ...defaultModelObjectCreator(coordinatesJson),
      ...practiceODM.omniData.coordinates,
    };
    return validatedODM;
  } catch (error) {
    console.log("Unable to validatePracticeODM: " + error);
    return null;
  }
};

export const validateMotivationODM = motivationODM => {
  try {
    const subSchemaJson = require(`./schema/motivation.json`);
    let defaultMotivation = defaultModelObjectCreator(subSchemaJson);
    return validateODM(defaultMotivation, motivationODM);
  } catch (error) {
    console.log("Unable to validateMotivationODM: " + error);
    return null;
  }
};

export const validateOnboardingODM = onboardingODM => {
  try {
    const subSchemaJson = require(`./schema/onboarding.json`);
    let defaultOnboarding = defaultModelObjectCreator(subSchemaJson);

    return validateODM(defaultOnboarding, onboardingODM);
  } catch (error) {
    console.log("Unable to validateOnboardingODM: " + error);
    return null;
  }
};

export const validateOrganizationODM = organizationODM => {
  try {
    let defaultOrg = createNewOrganization();

    let validatedODM = deepMerge(defaultOrg, organizationODM);

    if (!validatedODM.omniData.hasOwnProperty("defaultAsssesmentType")) {
      validatedODM.omniData["defaultAsssesmentType"] = defaultOrg.omniData.defaultAsssesmentType;
    }

    if (!validatedODM.omniData.hasOwnProperty("supportedAssessmentTypes")) {
      validatedODM.omniData["supportedAssessmentTypes"] =
        defaultOrg.omniData.supportedAssessmentTypes;
    }

    if (!validatedODM.omniRelationships.hasOwnProperty("relatedData")) {
      validatedODM.omniRelationships["relatedData"] = [];
    }

    const addressJson = require(`./schema/address.json`);
    validatedODM.omniData.address = {
      ...defaultModelObjectCreator(addressJson),
      ...organizationODM.omniData.address,
    };

    const contactPointsJson = require(`./schema/contactPoint.json`);
    if (typeof validatedODM.omniData.contactPoints !== "undefined") {
      validatedODM.omniData.contactPoints.forEach = contactPoint =>
        (contactPoint = {
          ...defaultModelObjectCreator(contactPointsJson),
          ...contactPoint,
        });
    } else {
      validatedODM.omniData.contactPoints = [];
    }

    const emailTemplatesJson = require(`./schema/emailTemplate.json`);
    if (typeof validatedODM.omniData.emailTemplates !== "undefined") {
      validatedODM.omniData.emailTemplates.forEach = emailTemplate =>
        (emailTemplate = {
          ...defaultModelObjectCreator(emailTemplatesJson),
          ...emailTemplate,
        });
    } else {
      validatedODM.omniData.emailTemplates = [];
    }

    const communicationsJson = require(`./schema/communicationRequest.json`);
    if (typeof validatedODM.omniData.communications !== "undefined") {
      validatedODM.omniData.communications.forEach = communication =>
        (communication = {
          ...defaultModelObjectCreator(communicationsJson),
          ...communication,
        });
    } else {
      validatedODM.omniData.communications = [];
    }

    return validatedODM;
  } catch (error) {
    console.log("Unable to validateOrganizationODM: " + error);
    return null;
  }
};

export const validateODM = (defaultODM, unvalidatedODM) => {
  try {
    let validatedODM = deepMerge(defaultODM, unvalidatedODM);
    for (const property in defaultODM) {
      if (
        typeof validatedODM[property] === "object" &&
        !Array.isArray(validatedODM[property]) &&
        validatedODM[property] !== null
      ) {
        validatedODM[property] = validateODM(defaultODM[property], unvalidatedODM[property]);
      }
    }
    return validatedODM;
  } catch (error) {
    console.log("Unable to migrate OmniDMOO: " + error);
    return null;
  }
};

export const validateConversationConfigurationODM = conversationConfigurationODM => {
  try {
    const subSchemaJson = require(`./schema/conversationConfiguration.json`);
    let defaultConversationConfiguration = defaultModelObjectCreator(subSchemaJson);
    return validateODM(defaultConversationConfiguration, conversationConfigurationODM);
  } catch (error) {
    console.log("Unable to validateConversationConfigurationODM: " + error);
    return null;
  }
};

export const validateInviteODM = invite => {
  try {
    const subSchemaJson = require(`./schema/invite.json`);
    let defaultInvite = defaultModelObjectCreator(subSchemaJson);

    // if (invite.omniData.onboardingAssessmentType === "omniMSSOnboard") {
    //   invite.omniData.onboardingAssessmentType = "omniMSOnboard";
    // }

    return validateODM(defaultInvite, invite);

    // return invite;
  } catch (error) {
    console.log("Unable to validateInviteODM: " + error);
    return null;
  }
};

export const validateReportODM = report => {
  try {
    const subSchemaJson = require(`./schema/report.json`);
    let defaultReport = defaultModelObjectCreator(subSchemaJson);
    return validateODM(defaultReport, report);
  } catch (error) {
    console.log("Unable to validateInviteODM: " + error);
    return null;
  }
};

export const createNewReportData = () => {
  try {
    const schemaJson = require(`./schema/report.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);
    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const validateCommunicationRequestODM = communicationRequestODM => {
  try {
    const subSchemaJson = require(`./schema/communicationRequest.json`);
    let defaultOnboarding = defaultModelObjectCreator(subSchemaJson);

    return validateODM(defaultOnboarding, communicationRequestODM);
  } catch (error) {
    console.log("Unable to validatecommunicationRequestODM: " + error);
    return null;
  }
};

export const validateCommunicationTemplateODM = communicationRequestODM => {
  try {
    const subSchemaJson = require(`./schema/communicationTemplate.json`);
    let defaultOnboarding = defaultModelObjectCreator(subSchemaJson);

    return validateODM(defaultOnboarding, communicationRequestODM);
  } catch (error) {
    console.log("Unable to validateCommunicationTemplateODM: " + error);
    return null;
  }
};
//#endregion

//#region CREATE Methods

export const createNewAssessment = () => {
  try {
    // Commented out for DEMO
    // const schemaJson = require(`./schema/assessments.json`);
    const schemaJson = require(`./proto/assessmentsWithScoring.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    const auditJson = require(`./schema/omniAudit.json`);
    returnObject.omniAudit = defaultModelObjectCreator(auditJson);

    const scheduleJson = require(`./schema/omniSchedule.json`);
    returnObject.omniSchedule = defaultModelObjectCreator(scheduleJson);

    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewUserData = () => {
  try {
    const schemaData = require(`./schema/user/userData.json`);
    let returnObject = defaultModelObjectCreator(schemaData);

    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewUser = (
  patient = false,
  provider = false,
  partner = false,
  administrator = false,
) => {
  try {
    const schemaJson = require(`./schema/user.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    const auditJson = require(`./schema/omniAudit.json`);
    returnObject.omniAudit = defaultModelObjectCreator(auditJson);

    const schemaData = require(`./schema/user/userData.json`);
    returnObject.omniData = defaultModelObjectCreator(schemaData);

    const addressJson = require(`./schema/address.json`);
    returnObject.omniData.address = defaultModelObjectCreator(addressJson);

    returnObject.omniData.patientData = null;
    if (patient) {
      const subSchemaJson = require(`./schema/user/patientData.json`);
      returnObject.omniData.patientData = defaultModelObjectCreator(subSchemaJson);
    }

    returnObject.omniData.providerData = null;
    if (provider) {
      const subSchemaJson = require(`./schema/user/providerData.json`);
      returnObject.omniData.providerData = defaultModelObjectCreator(subSchemaJson);
    }

    returnObject.omniData.partnerData = null;
    if (partner) {
      const subSchemaJson = require(`./schema/user/partnerData.json`);
      returnObject.omniData.partnerData = defaultModelObjectCreator(subSchemaJson);
    }

    returnObject.omniData.administratorData = null;
    if (administrator) {
      const subSchemaJson = require(`./schema/user/administratorData.json`);
      returnObject.omniData.administratorData = defaultModelObjectCreator(subSchemaJson);
    }

    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewPractice = () => {
  try {
    const schemaJson = require(`./schema/practice.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    const auditJson = require(`./schema/omniAudit.json`);
    returnObject.omniAudit = defaultModelObjectCreator(auditJson);

    const addressJson = require(`./schema/address.json`);
    returnObject.omniData.address = defaultModelObjectCreator(addressJson);

    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewMotivation = () => {
  try {
    const schemaJson = require(`./schema/motivation.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    const auditJson = require(`./schema/omniAudit.json`);
    returnObject.omniAudit = defaultModelObjectCreator(auditJson);

    const scheduleJson = require("./schema/omniSchedule.json");
    returnObject.omniSchedule = defaultModelObjectCreator(scheduleJson);

    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewOnboarding = userDataODM => {
  try {
    const schemaJson = require(`./schema/onboarding.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    let validatedODM = deepMerge(createNewUserData(), userDataODM);

    validatedODM.omniData = userDataODM;

    returnObject["user"] = userDataODM;

    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewOrganization = () => {
  try {
    const schemaJson = require(`./schema/organization.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    const auditJson = require(`./schema/omniAudit.json`);
    returnObject.omniAudit = defaultModelObjectCreator(auditJson);

    const addressJson = require(`./schema/address.json`);
    returnObject.omniData.address = defaultModelObjectCreator(addressJson);

    const communicationJson = require(`./schema/communicationRequest.json`);
    returnObject.omniData.communications = defaultModelObjectCreator(communicationJson);

    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewConversationConfiguration = () => {
  try {
    const schemaJson = require(`./schema/conversationConfiguration.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    const auditJson = require(`./schema/omniAudit.json`);
    returnObject.omniAudit = defaultModelObjectCreator(auditJson);

    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewInvite = userType => {
  try {
    const schemaJson = require(`./schema/invite.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    const auditJson = require(`./schema/omniAudit.json`);
    returnObject.omniAudit = defaultModelObjectCreator(auditJson);

    returnObject.omniData.userData = createNewUserData();

    delete returnObject.omniData["inviteKey"];

    delete returnObject.omniRelationships["userID"];

    returnObject.omniData.userType = userType;

    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewRelationship = omniRelationshipType => {
  try {
    const schemaJson = require(`./schema/relationship.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    returnObject.omniRelationshipType = omniRelationshipType;
    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewUserRelationship = (userODM, omniRelationshipType) => {
  try {
    const schemaJson = require(`./schema/relationship.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    returnObject._id = userODM._id;

    if (userODM.omniData.patientData != null) {
      returnObject.type = constants.omniRelationshipUserTypes.patient;
    }

    if (userODM.omniData.providerData != null) {
      returnObject.type = constants.omniRelationshipUserTypes.provider;
    }

    if (userODM.omniData.partnerData != null) {
      returnObject.type = constants.omniRelationshipUserTypes.partner;
    }

    if (userODM.omniData.administratorData != null) {
      returnObject.type = constants.omniRelationshipUserTypes.administrator;
    }

    returnObject.omniRelationshipType = omniRelationshipType;
    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewSymptom = () => {
  try {
    const schemaJson = require(`./schema/user/symptom.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);
    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewContact = () => {
  try {
    const schemaJson = require(`./schema/user/contact.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);
    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewPatientData = () => {
  try {
    const schemaJson = require(`./schema/user/patientData.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);
    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewOmniAudit = () => {
  try {
    const auditJson = require(`./schema/omniAudit.json`);
    let returnObject = defaultModelObjectCreator(auditJson);

    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewEmailTemplate = () => {
  try {
    const schemaJson = require(`./schema/emailTemplate.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewReport = () => {
  try {
    const schemaJson = require(`./schema/report.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewCommunicationRequest = () => {
  try {
    const schemaJson = require(`./schema/communicationRequest.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    returnObject.omniData.batchId = uuid();
    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewCommunicationTemplate = () => {
  try {
    const schemaJson = require(`./schema/communicationTemplate.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    const emailTemplate = require(`./schema/emailTemplate.json`);
    returnObject.omniData.emailTemplate = defaultModelObjectCreator(emailTemplate);
    returnObject.omniData.emailTemplate.overrideReplyToAddress = "coach@omnisciahealth.com";
    returnObject.omniData.emailTemplate.overrideEmailSource = "coach@omnisciahealth.com";
    const smsTemplate = require(`./schema/smsTemplate.json`);
    returnObject.omniData.smsTemplate = defaultModelObjectCreator(smsTemplate);

    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewKPI = () => {
  try {
    const schemaJson = require(`./schema/kpi.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createNewBotpressBot = () => {
  try {
    const schemaJson = require(`./schema/botpressBot.json`);
    let returnObject = defaultModelObjectCreator(schemaJson);

    return returnObject;
  } catch (error) {
    console.log(error);
    return null;
  }
};

//#endregion
